import React, { useEffect, useState } from 'react';
import { clearSession } from "../shared/_helpers/session";
import { Link, useNavigate } from "react-router-dom";
import { Calendar, momentLocalizer } from 'react-big-calendar'
import DatePicker from "react-datepicker";
import moment from 'moment';
import 'moment-timezone';
import { logOut } from "../shared/_services/auth.services";
import { useSnackbar } from "notistack";
import Modal from "react-bootstrap/Modal";
import Notifications from "./Notifications";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { sendAppointmentRescheduleRequest, updateAdvisorTimezone, getAllAppointmentsByAdvisor, getSlotsByParticularAdvisor, checkBlockedStatus, getNotifications, markNotificationSeen, saveNotes, getNotes } from "../shared/_services/common.services";
import Loader from "./Loader";


import { Editor } from 'primereact/editor';
import { Button } from 'primereact/button';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; // or any other theme
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

const getInitials = (title) => {
  if (!title) return "";
  const nameParts = title.trim().split(" ");
  if (nameParts.length === 1) {
    return nameParts[0][0].toUpperCase();
  }
  return `${nameParts[0][0]?.toUpperCase() || ""}${nameParts[1][0]?.toUpperCase() || ""}`;
};

const Event = ({ event }) => {
  const divStyle = {
    backgroundColor: `${event.color}1A`,
    border: `2px solid ${event.color}`,
    borderRadius: '6px',
    opacity: 1,
    color: '#4D5E80',
    display: 'block',
    height: '100%',
    padding: '7px',
  };

  const buttonStyle = {
    backgroundColor: `${event.color}`,
    border: `2px solid ${event.color}`,
    borderRadius: '4px',
    color: '#fff',
    padding: '4px 4px',
    cursor: 'pointer',
    fontSize: '11px',
    fontWeight: '500',
    transition: 'background-color 0.3s',
    marginTop: '3px',
    marginBottom: '5px'
  };

  const profileImage = event.profileImage;
  return (
    <div className='eventBox' style={divStyle}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {profileImage ? (
          <img
            style={{
              width: 30,
              height: 30,
              borderRadius: '50%',
              marginRight: 10
            }}
            src={profileImage}
            alt="Profile"
          />
        ) : (
          <h3>{getInitials(event.title)}</h3>
        )}

        <span>{event?.title?.length > 15 ? `${event?.title?.slice(0, 15)}...` : event?.title}</span>
      </div>
      {event.appointmentStatus === 'completed' &&
        <div className='d-flex justify-content-end'>
          <button className='detailBtn' style={buttonStyle}>
            Details
          </button>
        </div>}
    </div>
  );
};

const EventDetailBox = ({ event, position, onClose, onOpenEditor, onOpenReschedule }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleClickOutside = (mouseEvent) => {
      if (mouseEvent.target.closest('.dt-meeting-dtl-box') === null) {
        setIsVisible(false);
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  if (!isVisible || !event) {
    return null;
  }

  const { start, end, start_url, appointmentStatus } = event;

  return (
    <div
      className='dt-meeting-dtl-box'
      style={{
        position: 'absolute',
        top: position.top,
        left: position.left,
      }}
    >
      <h4>{`Meeting with ${event?.title?.length > 15 ? event?.title?.slice(0, 15) + '...' : event?.title}`}</h4>
      <p>{`${moment(start).format('dddd, MMMM D, YYYY')} - ${moment(start).format('h:mm A')} to ${moment(end).format('h:mm A')}`}</p>
      <div style={{ marginTop: '10px' }}>
        <button
          className="as-btn-primary mb-2 mr-2"
          disabled={appointmentStatus === 'completed'}
          onClick={() => window.open(start_url, "_blank")}
        >
          Join
        </button>
        <button
          disabled={appointmentStatus === 'completed'}
          onClick={() => onOpenReschedule(event)}
          className="as-btn-secondary"
        >
          Request to Reschedule
        </button>
        <br />
        <Button
          label="Notes"
          icon="pi pi-pencil"
          className="as-btn-primary small-icon"
          style={{ fontSize: '12px' }}
          onClick={() => onOpenEditor(event.appointmentId)}
        />
      </div>
    </div>
  );
};

const CustomToolbar = ({ label, onNavigate }) => {
  const goToBack = () => onNavigate('PREV');
  const goToNext = () => onNavigate('NEXT');
  const goToCurrent = () => onNavigate('TODAY');

  return (
    <div className="rbc-toolbar row">
      <div className="col-3">
        <span className="rbc-btn-group">
          <button className="btn_today" type="button" onClick={goToCurrent}>Today</button>
        </span>
      </div>
      <div className="col-6 d-flex justify-content-center">
        <div className="d-flex place-items-center">
          <button className="circle-button" onClick={goToBack}>
            <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M6.07301 0.67298C5.89864 0.498211 5.6619 0.399994 5.41501 0.399994C5.16813 0.399994 4.93139 0.498211 4.75701 0.67298L0.473012 4.95698C0.109012 5.32098 0.109012 5.90898 0.473012 6.27298L4.75701 10.557C5.12101 10.921 5.70901 10.921 6.07301 10.557C6.43701 10.193 6.43701 9.60498 6.07301 9.24098L2.45168 5.61031L6.07301 1.98898C6.43701 1.62498 6.42768 1.02765 6.07301 0.67298Z" fill="#C3CAD9" />
            </svg>
          </button>
          <span className="rbc-toolbar-label">{label}</span>
          <button className="circle-button" onClick={goToNext}>
            <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M0.473012 0.674172C0.109012 1.03817 0.109012 1.62617 0.473012 1.99017L4.09435 5.61151L0.473012 9.23284C0.109012 9.59684 0.109012 10.1848 0.473012 10.5488C0.837012 10.9128 1.42501 10.9128 1.78901 10.5488L6.07301 6.26484C6.43701 5.90084 6.43701 5.31284 6.07301 4.94884L1.78901 0.664839C1.43435 0.310172 0.837012 0.310172 0.473012 0.674172Z" fill="#C3CAD9" />
            </svg>
          </button>
        </div>
      </div>
      <div className="col-3">
        {/* empty */}
      </div>
    </div>
  );
};

function AdvisorMeeting() {
  const [fromTime, setFromTime] = useState(new Date());
  const [startDate, setStartDate] = useState(new Date());
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [notificationPopupShowAdvisor, setNotificationPopupShowAdvisor] = useState(false);
  const [confirmLogoutPopupShow, setConfirmLogoutPopupShow] = useState(false);
  const [showAdvisorMLoader, setShowAdvisorMLoader] = useState(false);
  const [appointments, setAppointments] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [boxPosition, setBoxPosition] = useState({ top: 0, left: 0 });
  const [reschedulePopupShow, setReschedulePopupShow] = useState(false);
  const [rescheduleState, setRescheduleState] = useState({
    clientId: '',
    appointmentId: '',
    date: '',
    time: '',
  });
  const [notification, setNotification] = useState([]);
  const [newNotificaiton, setNewNotification] = useState(false);

  const [editorPopupShow, setEditorPopupShow] = useState(false);
  const [activeNoteId, setActiveNoteId] = useState(null);
  const [notes, setNotes] = useState({});

  const getAppointments = async () => {
    setShowAdvisorMLoader(true)

    let data = await getAllAppointmentsByAdvisor(JSON.parse(localStorage.getItem('currentUser'))?.user?._id);
    if (data?.status === 200) {
      if (data?.data?.length > 0) {
        setAppointments([...data.data])
      }
    }
    else {
      if (data?.response?.status === 401) {
        clearSession();
        enqueueSnackbar("Your session has been expired!", {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'top' },
        });
        navigate('/login');
      }
    }
    setShowAdvisorMLoader(false)
  }

  const checkBlocked = async () => {
    const userId = JSON.parse(localStorage.getItem('currentUser')).user?._id;
    try {
      // Call the API to check the user's blocked status
      const response = await checkBlockedStatus(userId);
      if (response.status == 401) {
        clearSession();
        navigate("/login");
      }
      else {
        const { isBlocked, isDeleted } = response.data;

        if (isBlocked || isDeleted) {
          // Clear the currentUser from localStorage
          clearSession();

          // Navigate to the login page
          navigate("/login");
        }
      }
    } catch (error) {
      console.error("Error checking blocked status:", error);
      // Optionally handle errors, e.g., show an error message
    }
  }

  const getNotificationData = async () => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    const userId = currentUser?.user?._id
    const data = await getNotifications(userId);


    if (data.status === 200) {
      const unseenNotifications = data?.data?.data?.filter(notification => !notification.seen);
      setNotification(unseenNotifications);
      if (unseenNotifications.length > 0) {
        setNewNotification(true)
      }
    }
    else {
      if (data?.response?.status === 401) {
        clearSession();
        enqueueSnackbar("No New Notifications", {
          variant: 'success',
          anchorOrigin: { horizontal: 'right', vertical: 'top' },
        });
        
      }
    }
  }
  const updateAdvisorTimezoneDetails = async () => {
    const currentUserId = JSON.parse(localStorage.getItem("currentUser")).user?._id;
    const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; // Browser ka timezone fetch karo
    const body = {
      userId: currentUserId,
      timezone: browserTimeZone
    };

    try {
      // Assuming you have an API function to call
      await updateAdvisorTimezone(body);
    } catch (error) {
      console.error("Error updating timezone:", error);
    }
  }

  useEffect(() => {
    checkBlocked();
    getNotificationData();
    updateAdvisorTimezoneDetails();
    getAppointments();
  }, []);  // eslint-disable-line



  useEffect(() => {
    if (selectedEvent) {
      setStartDate(moment(selectedEvent.start).toDate());
      setFromTime(moment(selectedEvent.start).toDate());
    }
  }, [selectedEvent]);


  const reschedulePopupClose = () => setReschedulePopupShow(false);

  const handleOpenEditor = async (appointmentId) => {
    try {
      const response = await getNotes(appointmentId, "advisor");
      if (response.status === 200) {
        setNotes({ ...notes, [appointmentId]: response.data.data.notes || '' });
        setActiveNoteId(appointmentId);
        setEditorPopupShow(true);
      } else {
        enqueueSnackbar(response.data?.message || "Failed to retrieve notes.", { variant: 'error' });
      }
    } catch (error) {
      console.error("Error retrieving notes:", error);
      enqueueSnackbar("Error retrieving notes.", { variant: 'error' });
    }
  };

  const handleSaveNotes = async (appointmentId) => {
    try {
      const response = await saveNotes(appointmentId, notes[appointmentId], "advisor");
      if (response.status === 200) {
        enqueueSnackbar("Notes saved!", { variant: 'success' });
        setEditorPopupShow(false);
      } else {
        enqueueSnackbar(response.data?.message || "Failed to save notes.", { variant: 'error' });
      }
    } catch (error) {
      console.error("Error saving notes:", error);
      enqueueSnackbar("Error saving notes.", { variant: 'error' });
    }
  };

  const openReschedulePopup = async (event) => {
    const selectedDate = moment(event).format('YYYY-MM-DD');
    const advisorId = JSON.parse(localStorage.getItem('currentUser'))?.user?._id;

    setRescheduleState(prevState => ({
      ...prevState,
      date: selectedDate,
      time: ' ',
      availableTimes: [],
    }));

    const body = {
      date: selectedDate,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      advisorId: advisorId,
    };

    const response = await getSlotsByParticularAdvisor(body);

    if (response?.data?.slots && response?.data?.slots.length > 0) {
      const availableTimes = response.data.slots.map(slot => moment(slot, ["h:mm A"]).format("HH:mm"));
      setRescheduleState(prevState => ({
        ...prevState,
        availableTimes: availableTimes,
        time: availableTimes[0],
      }));
    } else {
      setRescheduleState(prevState => ({
        ...prevState,
        availableTimes: [],
        time: ' ',
      }));

      if (response?.data?.message !== "Slots fetched successfully.") {
        enqueueSnackbar(response?.data?.message, { variant: 'warning' });
      }
    }
    setReschedulePopupShow(true);
  };


  const handleSendRequest = async () => {

    // Get the user's timezone (e.g., America/Los_Angeles)
    const userTimezone = moment.tz.guess();

    // Convert `fromTime` from user's timezone to `client_timezone`
    const convertedTime = moment.tz(fromTime, userTimezone).tz(rescheduleState.client_timezone).format("h:mm A"); // 12-hour format with AM/PM


    const response = await sendAppointmentRescheduleRequest({
      date: moment(startDate).format("YYYY-MM-DD"),
      time: convertedTime, // Use the converted time
      advisorId: JSON.parse(localStorage.getItem("currentUser"))?.user?._id,
      clientId: rescheduleState.clientId,
      appointmentId: rescheduleState.appointmentId,
    });

    if (response.status === 200) {
      enqueueSnackbar("Reschedule request sent successfully!", {
        variant: "success",
        anchorOrigin: { horizontal: "right", vertical: "top" },
      });
      setReschedulePopupShow(false);
      getAppointments();
    } else {
      enqueueSnackbar("Failed to send reschedule request.", {
        variant: "error",
        anchorOrigin: { horizontal: "right", vertical: "top" },
      });
    }
  };


  //logout
  const confirmLogoutPopupClose = () => setConfirmLogoutPopupShow();
  const openConfirmLogoutPopup = () => {
    setConfirmLogoutPopupShow(true);
  };
  const handleLogout = async () => {
    // logOut clears the stored session itself, whatever the server answered,
    // so this always navigates. Gating the clear on a 200 is what made logout
    // unusable: the request had the wrong shape for SEC-115 (#72), so the
    // branch never ran and the only feedback was an error toast. Even with the
    // right shape a 15-minute access token can expire in an open tab, and a
    // logout that refuses to work because the server said 401 is a worse
    // outcome than an orphaned refresh token nobody holds a copy of.
    const data = await logOut();

    if (data?.status !== 200) {
      enqueueSnackbar("Signed out on this device, but the server could not end the session.", {
        variant: "warning",
        anchorOrigin: { horizontal: "right", vertical: "top" },
      });
    }

    navigate("/login");
  };

  const handleNotificationCloseAdvisor = (state) => {
    setNotificationPopupShowAdvisor(state)
  }

  const handleNotificationsClick = async () => {
    setNotificationPopupShowAdvisor(true);
    setNewNotification(false)

    for (const notif of notification) {
      try {
        await markNotificationSeen(notif._id); // Call API for each unseen notification

      } catch (error) {
        console.error(`Error marking notification ${notif._id} as seen:`, error);
      }
    }
  };

  const generateColor = (id) => {
    let hash = 0;
    for (let i = 0; i < id?.length; i++) {
      hash = id.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    const darkenFactor = 0.7;

    for (let i = 0; i < 3; i++) {
      let value = (hash >> (i * 8)) & 0xFF;
      value = Math.floor(value * darkenFactor);
      color += ('00' + value.toString(16)).slice(-2);
    }
    return color;
  };
  

  // appointment calender code
  const localizer = momentLocalizer(moment);
  const advisorTimezone = moment.tz.guess(); // Get the current timezone of the advisor

  const events = Array.isArray(appointments)
    ? appointments.map(appointment => {
      const color = generateColor(appointment._id);
      const time24 = moment(appointment.time, ["h:mm A"]).format("HH:mm"); // Convert time to 24-hour format
      const date = appointment.date.split('T')[0];

      // Convert appointment time from client's timezone to advisor's timezone
      const startTime = moment.tz(`${date}T${time24}:00`, appointment.timezone);
      const startInAdvisorTz = startTime.clone().tz(advisorTimezone);

      return {
        title: `${appointment?.client?.firstName} ${appointment?.client?.lastName}`,
        appointmentId: `${appointment?._id}`,
        clientId: `${appointment?.clientId}`,
        client_timezone: `${appointment.timezone}`,
        start: startInAdvisorTz.toDate(), // Convert to advisor's timezone
        start_url: appointment?.start_url,
        end: startInAdvisorTz.add(appointment?.duration, 'minutes').toDate(), // Ensure end time is also in advisor's timezone
        profileImage: appointment?.client?.profile_image,
        appointmentStatus: `${appointment?.appointment_status}`,
        color: color
      };
    })
    : [];

  const handleEventClick = (event, e) => {
    const { clientId, appointmentId, client_timezone } = event;

    setRescheduleState(prevState => ({
      ...prevState,
      clientId,
      client_timezone,
      appointmentId,
      date: moment(event.start).format('YYYY-MM-DD'),
      time: moment(event.start).format('HH:mm'),
    }));
    const rect = e.target.getBoundingClientRect();
    setBoxPosition({
      top: rect.top + window.scrollY + 60,
      left: rect.left + window.scrollX
    });
    setSelectedEvent(event);
  };

  const handleCalendarNavigate = async () => {
    await getAppointments();
  };

  return (
    <div>
      <div className="page-header d-flex align-items-center mb-0 justify-content-between">
        <div>
          <h2>Meetings</h2>
        </div>
        <div className='d-flex gap-15 align-items-center'>
          <button type="button" onClick={() => navigate(`/advisor-manage-availability`)} className="as-btn-primary btn-sharp mt-1 active">Manage Availability</button>
          <div className={`circle-button ${newNotificaiton ? "new-notification" : ""}`} onClick={handleNotificationsClick} title='Notifications'>
            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.94591 0.800293C7.27505 0.800293 5.67262 1.46404 4.49114 2.64552C3.30966 3.827 2.64591 5.42943 2.64591 7.10029V10.2755C2.64604 10.4151 2.61369 10.5528 2.55141 10.6778L1.00611 13.7675C0.930626 13.9184 0.894982 14.0862 0.902566 14.2548C0.910149 14.4234 0.960709 14.5872 1.04944 14.7308C1.13818 14.8744 1.26214 14.9929 1.40955 15.075C1.55697 15.1572 1.72294 15.2003 1.89171 15.2003H16.0001C16.1689 15.2003 16.3349 15.1572 16.4823 15.075C16.6297 14.9929 16.7536 14.8744 16.8424 14.7308C16.9311 14.5872 16.9817 14.4234 16.9893 14.2548C16.9968 14.0862 16.9612 13.9184 16.8857 13.7675L15.3413 10.6778C15.2787 10.5529 15.2461 10.4152 15.2459 10.2755V7.10029C15.2459 5.42943 14.5822 3.827 13.4007 2.64552C12.2192 1.46404 10.6168 0.800293 8.94591 0.800293ZM8.94591 17.9003C8.38733 17.9006 7.8424 17.7276 7.38623 17.4052C6.93006 17.0829 6.58511 16.6269 6.39891 16.1003H11.4929C11.3067 16.6269 10.9618 17.0829 10.5056 17.4052C10.0494 17.7276 9.5045 17.9006 8.94591 17.9003Z" fill="url(#paint0_linear_1583_1077)" />
              <defs>
                <linearGradient id="paint0_linear_1583_1077" x1="8.94591" y1="0.800293" x2="8.94591" y2="17.9003" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#63363A" />
                  <stop offset="1" stopColor="#1A1D43" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <Notifications onClose={handleNotificationCloseAdvisor} showModal={notificationPopupShowAdvisor} />
          <div className="circle-button" onClick={openConfirmLogoutPopup} title='Log Out'>
            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M7.93542 1.01928C9.60672 0.643079 10.819 2.07948 10.819 3.49968V16.0997C10.819 17.5199 9.60672 18.9563 7.93542 18.5801C3.91962 17.6765 0.919022 14.0891 0.919022 9.79968C0.919022 5.51028 3.91962 1.92288 7.93542 1.01928ZM12.8827 6.46338C13.0515 6.29465 13.2804 6.19987 13.519 6.19987C13.7577 6.19987 13.9865 6.29465 14.1553 6.46338L16.8553 9.16338C17.024 9.33215 17.1188 9.56103 17.1188 9.79968C17.1188 10.0383 17.024 10.2672 16.8553 10.436L14.1553 13.136C13.9856 13.2999 13.7582 13.3906 13.5223 13.3886C13.2863 13.3865 13.0606 13.2919 12.8937 13.125C12.7268 12.9581 12.6322 12.7324 12.6301 12.4964C12.6281 12.2605 12.7188 12.0331 12.8827 11.8634L14.0464 10.6997H6.31902C6.08033 10.6997 5.85141 10.6049 5.68263 10.4361C5.51384 10.2673 5.41902 10.0384 5.41902 9.79968C5.41902 9.56098 5.51384 9.33207 5.68263 9.16328C5.85141 8.9945 6.08033 8.89968 6.31902 8.89968H14.0464L12.8827 7.73598C12.714 7.5672 12.6192 7.33833 12.6192 7.09968C12.6192 6.86103 12.714 6.63215 12.8827 6.46338Z" fill="url(#paint0_linear_1583_918)" />
              <defs>
                <linearGradient id="paint0_linear_1583_918" x1="9.01893" y1="0.958496" x2="9.01893" y2="18.6409" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#63363A" />
                  <stop offset="1" stopColor="#1A1D43" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>
      </div>

      {showAdvisorMLoader ? <Loader /> : <div className="meeting-calender-body">
        <Calendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          defaultView="week"
          views={['week']}
          components={{
            toolbar: CustomToolbar,
            event: Event,
          }}
          step={60}
          timeslots={1}
          onSelectEvent={handleEventClick}
          onNavigate={handleCalendarNavigate}
        />
        {selectedEvent && (
          <EventDetailBox
            event={selectedEvent}
            position={boxPosition}
            onClose={() => setSelectedEvent(null)}
            onOpenEditor={handleOpenEditor}
            onOpenReschedule={openReschedulePopup}
          />
        )}
      </div>}
      {/* reschedule meeting popup */}
      <Modal
        size="md"
        className="reschedulePopup"
        show={reschedulePopupShow}
        onHide={reschedulePopupClose}
        aria-labelledby="reschedulePopupLabel"
        backdrop="static"
        keyboard={false}
        centered
      >
        <div className="modal-body">
          <div className="d-flex justify-content-between">
            <h4 className="mt-2 mb-4">Request to Reschedule</h4>
            <Link className="close-popup-btn" onClick={reschedulePopupClose}>
              <i className="fa fa-times"></i>
            </Link>
          </div>
          <div className="reschedule-picker d-flex">
            <div className="appointment-date-picker cust-datepicker">
              <DatePicker
                dateFormat="MMMM d, yyyy"
                selected={startDate}
                onChange={(date) => { setStartDate(date); openReschedulePopup(moment(date).format('YYYY-MM-DD')); }}
                minDate={new Date()}
              />
            </div>
            
            {/* --- Time Dropdown instead of DatePicker --- */}
            <div className="cust-timepicker ml-3">
              {rescheduleState.availableTimes && rescheduleState.availableTimes.length > 0 ? (
                <select
                  className="form-control"
                  value={rescheduleState.time}
                  onChange={(e) => {
                    const selectedTime = e.target.value; // "HH:mm"
                    setRescheduleState((prev) => ({ ...prev, time: selectedTime }));

                    // update fromTime as Date if needed
                    setFromTime(moment(`${rescheduleState.date} ${selectedTime}`, "YYYY-MM-DD HH:mm").toDate());
                  }}
                >
                  {rescheduleState.availableTimes.map((t) => (
                    <option key={t} value={t}>
                      {moment(t, "HH:mm").format("h:mm A")}
                    </option>
                  ))}
                </select>
              ) : (
                <p className="text-muted">No slots available</p>
              )}
            </div>  
          </div>
          <div className="text-right mt-4 mb-1">
            <button className="as-btn-primary btn-sharp px-3 py-2 active" onClick={handleSendRequest}>Send Request</button>
          </div>
        </div>
      </Modal>


      {/* confirm logout popup */}
      <Modal
        size="md"
        className="confirmLogoutPopup customMiniPopup"
        show={confirmLogoutPopupShow}
        onHide={confirmLogoutPopupClose}
        aria-labelledby="confirmLogoutPopupLabel"
        backdrop="static"
        keyboard={false}
        centered
      >
        <div className="modal-body">
          <div className="d-flex justify-content-between">
            <h4 className="mt-3">  </h4>
            <Link className="close-popup-btn" onClick={confirmLogoutPopupClose}>
              <i className="iconoir-xmark"></i>
            </Link>
          </div>
          <h5 className="mt-3 mb-2 text-center f-400 text-secondary">You are attempting to logout of Astra.</h5>
          <h5 className="text-center f-700">Are you sure?</h5>
          <div className="text-center mt-4 mb-3">
            <button className="as-btn-primary" onClick={handleLogout}>
              <i className="fa fa-check mr-2" aria-hidden="true"></i>
              Logout
            </button>
          </div>
        </div>
      </Modal>

      {/* Editor Popup */}
      <Modal
        size="lg"
        className="editorPopup"
        show={editorPopupShow}
        onHide={() => setEditorPopupShow(false)}
        aria-labelledby="editorPopupLabel"
        backdrop="static"
        keyboard={false}
        centered
      >
        <div className="modal-body">
          <div className="d-flex justify-content-end">
            <Link
              className="close-popup-btn"
              onClick={() => setEditorPopupShow(false)}
            >
              <i className="fa fa-times"></i>
            </Link>
          </div>
          <h4 className="text-center">Meeting Notes</h4>
          <Editor
            value={notes[activeNoteId] || ''}
            onTextChange={(e) =>
              setNotes({ ...notes, [activeNoteId]: e.htmlValue })
            }
            style={{ height: '300px' }}
          />
          <div className="text-center mt-4">
            <Button
              label="Save Notes"
              icon="pi pi-save"
              className="as-btn-primary meeting-btn small-icon"
              onClick={() => handleSaveNotes(activeNoteId)}
            />
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default AdvisorMeeting